import React, { memo } from "react";
import {
    RiAddLine, RiArticleLine, RiChatNewLine, RiTicketLine,
} from "@remixicon/react";
import Dropdown from "../../../theme/dropdown/Dropdown";
import { Paths } from "../../../../contexts/Routing";
import useCreateTicket from "../../../../contexts/CreateTicketContext";

function CreateNewWidget({ metricPathPrefix }: { metricPathPrefix: string[] }) {
    const createTicket = useCreateTicket();

    return (
        <Dropdown>
            <Dropdown.Toggle size="small" prefixIcon={<RiAddLine />}>
                Create
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Link
                    to={Paths.AGENT_COMPOSE}
                    metricPath={[...metricPathPrefix, "conversation", "new"]}
                    prefixIcon={<RiChatNewLine />}
                >
                    Conversation
                </Dropdown.Link>
                <Dropdown.Item
                    metricPath={[...metricPathPrefix, "ticket", "create"]}
                    prefixIcon={<RiTicketLine />}
                    onClick={() => createTicket.show()}
                >
                    Ticket
                </Dropdown.Item>
                <Dropdown.Link
                    metricPath={[...metricPathPrefix, "article", "new"]}
                    to={Paths.ANSWERS_NEW}
                    prefixIcon={<RiArticleLine />}
                >
                    Article
                </Dropdown.Link>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default memo(CreateNewWidget);
